module.exports = __webpack_public_path__ + "img/tax-included.15c5cec9.svg";